import { defineAsyncComponent } from 'vue';

export const TableFilterBroadcastList = defineAsyncComponent(() => import('./TableFilterBroadcastList.vue'));
export const TableTopBroadcastList = defineAsyncComponent(() => import('./TableTopBroadcastList.vue'));